export const ENROLLMENT_SUPPORT_PHONE = {
  display: '(872) 314-1365',
  compactDisplay: '872-314-1365',
  href: 'tel:8723141365'
} as const

export const ENROLLMENT_PUBLIC_LINKS = {
  home: 'https://www.160drivingacademy.com/',
  cdlTraining: 'https://www.160drivingacademy.com/truck-driving-classes/class-a/',
  privacyPolicy: 'https://www.160drivingacademy.com/privacy-policy/',
  termsOfService: 'https://www.160drivingacademy.com/terms-of-service/'
} as const

export const ENROLLMENT_FIELD_LABELS = {
  firstName: 'First Name',
  lastName: 'Last Name',
  phoneNumber: 'Phone Number',
  emailAddress: 'Email Address',
  fullAddress: 'Full Address',
  city: 'City',
  state: 'State',
  zipCode: 'Zip Code'
} as const

export const ENROLLMENT_VALIDATION_MESSAGES = {
  firstNameRequired: 'First name is required.',
  lastNameRequired: 'Last name is required.',
  emailRequired: 'Email address is required.',
  emailShortRequired: 'Email is required.',
  phoneRequired: 'Phone number is required.',
  phoneInvalid: 'Please enter a valid 10-digit phone number.',
  addressRequired: 'Full address is required.',
  cityRequired: 'City is required.',
  stateRequired: 'State is required.',
  zipRequired: 'Zip code is required.'
} as const

export const ENROLLMENT_COMMON_MESSAGES = {
  sessionExpired: 'Your enrollment session has expired. Please start again.',
  sessionMissing: 'Your enrollment session is missing. Please restart the enrollment flow.',
  saveStepFailed: 'Unable to save this step right now. Please try again.',
  saveEndorsementsFailed: 'Unable to save endorsements right now. Please try again.',
  submitFailed: 'Unable to submit your enrollment right now. Please try again.',
  submitShortFailed: 'Unable to submit. Please try again.',
  governmentAssistanceSubmitFailed:
    'Unable to submit your government assistance enrollment right now. Please try again.',
  startSessionFailed: 'Unable to start your enrollment session. Please try again.',
  startEnrollmentFailed: 'Unable to start enrollment. Please try again.',
  createAccountFailed: 'Unable to create your account right now. Please try again.',
  loginFailed: 'Unable to log in right now. Please try again.',
  verifyCodeFailed: 'Unable to verify your code right now. Please try again.',
  resendCodeFailed: 'Unable to resend your code right now. Please try again.',
  enrollmentAgreementOpenFailed: 'Unable to open your enrollment agreement. Please try again.',
  enrollmentAgreementPrepareFailed:
    'Unable to prepare your enrollment agreement. Please try again.',
  startDateMustBeMonday:
    'Classroom programs must start on a Monday. Please choose a Monday start date before continuing.',
  emergencyContactPhoneInvalid:
    'Please enter a valid emergency contact phone number or leave it blank.',
  completeApplicationFirst:
    'Please complete the application form before continuing without an account.',
  termsRequired: 'You must agree to the terms to continue.',
  callRequestFailed: 'Unable to submit your call request right now. Please try again.'
} as const

export const ENROLLMENT_LOCATION_MESSAGES = {
  zipHelp: 'ZIP code is pre-filled from your application and cannot be changed here.',
  loading: 'Loading training locations...',
  invalidZip: 'Please enter a valid 5-digit ZIP code so we can find nearby locations.',
  loadFailed: 'Unable to load training locations right now. Please try again.',
  missingLicenseState: "Please go back and select your driver's license state first.",
  noLocations: 'No eligible self-enrollment locations are available right now.',
  noLocationsHelp: 'Please call us and we will help you choose the best option.',
  noLicenseStateLocations: "We could not find an eligible location in your driver's license state.",
  noLicenseStateLocationsHelp:
    "Online enrollment is available only for branches in the same state as your driver's license. Please call us to discuss your options.",
  loadingBranches: 'Loading branch locations...',
  noBranches: 'No branch locations are available right now. Please call us and we will help.',
  enterZipFirst: 'Enter ZIP code first',
  loadingPlaceholder: 'Loading nearby locations...',
  invalidZipPlaceholder: 'Enter a valid 5-digit ZIP code',
  noLocationsPlaceholder: 'No eligible locations found',
  noLicenseStateLocationsPlaceholder: 'No locations match your license state',
  missingLicenseStatePlaceholder: 'Select license state first',
  unavailablePlaceholder: 'Locations unavailable'
} as const

export const ENGLISH_TEST_MESSAGES = {
  answerSubmitFailed: 'Unable to submit the English test answer right now. Please try again.',
  testSubmitFailed: 'Unable to submit the English test right now. Please try again.',
  loadFailed: 'Unable to load the English test right now.',
  startFailed: 'Unable to start the English test right now. Please try again.',
  noQuestions: 'The default English test has no available questions yet.',
  assessmentMissing: 'The assessment has not started yet. Please wait a moment and try again.',
  assessmentMissingClose:
    'The assessment has not started yet. Please close this window and try again.',
  missingAnswerData: 'A question response is missing required answer data.'
} as const

export const DOCUSIGN_RETURN_MESSAGES = {
  declined: 'Signing was declined. Please contact us if you need help.',
  expired: 'The signing session expired. Open the agreement again for a fresh secure session.',
  incomplete: 'Signing was not completed. You can reopen the agreement when ready.'
} as const
